import { createContext } from 'react';

import WorkflowService from './Services/WorkflowService';

const workflowService = new WorkflowService();
export const workflowContext = createContext(workflowService);
